module.exports = __webpack_public_path__ + "vi.9d033b798b22ea28d51d.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/vi.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/vi.svg
// module chunks = styles